import React from "react";
import DiscoveryContainer from "../metahuts/DiscoveryContainer";

const Discovery = () => {
    return (
        <div className="container mx-auto relative pt-162 min-h-calc-head py-8">
            <DiscoveryContainer />
        </div>
    )
}

export default Discovery;